import "./PoliticalCandidate.scss";

const PoliticalCandidate = ({ coalition, color }) => {
  const firstname = coalition[0]?.candidates[0]?.fullname.split(" ")[0] || "cargando...";
  const lastname = coalition[0]?.candidates[0]?.fullname.split(" ")[1] || "cargando..."; //+ " " + coalition[0].candidates[0].fullname.split(" ")[2];
  const votes_percent = coalition[0]?.candidates[0]?.votes_percent || "00.00";
  const votes = coalition[0]?.candidates[0]?.votes || "00000";
  const avatar = coalition[0]?.candidates[0]?.avatar || "";

  return (
    <div className="p-candidate">
      <div
        className="p-candidate__header"
        style={{ borderTop: color + " solid 7px", borderBottom: color + " solid 7px" }}
      >
        <div className="p-candidate__info">
          <span className="p-candidate__info-firstname">{firstname}</span>
          <span className="p-candidate__info-lastname">{lastname}</span>
          <span className="p-candidate__info-percent">{votes_percent}%</span>
          <span className="p-candidate__info-number">VOTOS: {new Intl.NumberFormat().format(votes)}</span>
        </div>
        <div className="p-candidate__avatar">
          <img src={avatar} alt="avatar pick" />
        </div>
      </div>
      <div className="p-candidate__list">
        <div className="p-candidate__list-header">
          <span>Candidatos</span>
          <span>Votos</span>
          <span>Porcentaje</span>
        </div>
        <div className="p-candidate__list-body">
          {coalition.slice(1).map((party, index) => (
            <div key={index} className="p-candidate__list-row">
              <span>
                {party.candidates[0].fullname.split(" ")[0] + " " + party.candidates[0].fullname.split(" ")[1]}
              </span>
              <span>{new Intl.NumberFormat().format(party.candidates[0].votes)}</span>
              <span>{party.candidates[0].votes_percent}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PoliticalCandidate;
